<template>
  <v-form ref="form">
    <v-container fluid style="height: calc(100vh - 64px)">
      <v-row style="height: 100%">
        <v-col cols="6" md="6" class="pt-0" style="height: 100%">
          <v-card ref="content" height="100%" class="project__card--left">
            <v-row no-gutters style="min-height: 104px">
              <v-col class="pa-3" cols="12" md="7">
                <!-- Editing on -->
                <template v-if="isEditing">
                  <v-text-field
                    class="mb-2"
                    outlined
                    hide-details
                    v-model="projectNamePL"
                    :label="$i18n.t(`projects.projectNamePL`)"
                  />
                  <v-text-field
                    class="mb-2"
                    outlined
                    hide-details
                    v-model="projectNameEN"
                    :label="$i18n.t(`projects.projectNameEN`)"
                  />
                  <v-text-field
                    class="mb-2"
                    outlined
                    hide-details
                    v-model="projectAbstractPL"
                    :label="$i18n.t(`projects.projectDescriptionPL`)"
                  />
                  <v-text-field
                    outlined
                    hide-details
                    v-model="projectAbstractEN"
                    :label="$i18n.t(`projects.projectDescriptionEN`)"
                  />
                </template>
                <!-- Editing off -->
                <template v-else v-show="project && project.title && project.title[$i18n.locale]">
                  <v-row no-gutters style="max-width: 40vw" class="px-2">
                    <v-col cols="12">
                      <v-tooltip v-if="project.title[$i18n.locale]" right content-class="tooltip__span">
                        <template v-slot:activator="{ on }">
                          <div class="headline text-truncate" v-on="on">{{ project.title[$i18n.locale] }}</div>
                        </template>
                        <span>{{ project.title[$i18n.locale] }}</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="project.abstract && project.abstract[$i18n.locale]"
                        right
                        content-class="tooltip__span"
                      >
                        <template v-slot:activator="{ on }">
                          <v-subheader class="pa-0" v-on="on">
                            <div class="text-truncate">{{ project.abstract[$i18n.locale] }}</div>
                          </v-subheader>
                        </template>
                        <span>{{ project.abstract[$i18n.locale] }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
              <v-col class="pa-3" cols="12" md="5">
                <v-btn
                  class="float-right"
                  fab
                  dark
                  :title="$i18n.t('dashboard.projects.addOffer')"
                  small
                  color="primary"
                  @click="showDefaultDialog"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
                <v-btn
                  class="float-right mr-1"
                  fab
                  dark
                  small
                  color="primary"
                  @click="showAttributesSettings"
                  :title="$i18n.t(`dashboard.projects.attributesSettings`)"
                >
                  <v-icon dark>mdi-settings</v-icon>
                </v-btn>
                <!-- Editing off -->
                <v-btn
                  v-if="!isEditing"
                  class="float-right mr-1"
                  fab
                  dark
                  small
                  color="primary"
                  @click="startEditing"
                  :title="$i18n.t(`projects.tools.edit`)"
                >
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
                <!-- Editing on -->
                <v-btn
                  v-if="isEditing"
                  class="float-right mr-1"
                  fab
                  dark
                  small
                  color="primary"
                  @click="stopEditing"
                  :title="$i18n.t(`projects.tools.editClose`)"
                >
                  <v-icon dark>mdi-close</v-icon>
                </v-btn>
                <v-btn
                  v-if="isEditing"
                  class="float-right mr-1"
                  fab
                  dark
                  small
                  color="primary"
                  @click="acceptEditing"
                  :title="$i18n.t(`default.saveEditing`)"
                >
                  <v-icon dark>mdi-content-save-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="pr-3 project" cols="12" md="12" sm="12">
                <v-btn
                  dark
                  small
                  class="project__button mr-1 primary"
                  @click="openActionDialog('getPPTX')"
                  :title="$i18n.t(`dashboard.table.getPPTX`)"
                >
                  <v-icon>mdi-file-powerpoint</v-icon>
                </v-btn>
                <v-btn
                  dark
                  small
                  class="project__button mr-1 primary"
                  @click="openActionDialog('getXLSX')"
                  :title="$i18n.t(`dashboard.table.getXLSX`)"
                >
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="12" class="pa-1" md="12" sm="12">
                <v-tabs v-model="activeTab" ref="tabs_1">
                  <v-tab>{{ $i18n.t('dashboard.source.cbre') }}</v-tab>
                </v-tabs>
              </v-col>
            </v-row>
            <v-row ref="offers" no-gutters class="overflow-y-auto">
              <v-col cols="12" style="height: 100%">
                <v-data-table
                  id="table-offers"
                  class="overflow-y-auto"
                  ref="sortableTable"
                  :headers="offersTableHeaders"
                  :loading="tableLoading"
                  :items="projectOffers"
                  disable-pagination
                  hide-default-footer
                  fixed-header
                  v-bar
                >
                  <template v-slot:header.custom_id="{ header }">{{
                    $i18n.t(`dashboard.table.${header.text}`)
                  }}</template>
                  <template v-slot:header.nazwa_nieruchomosci="{ header }">{{
                    $i18n.t(`dashboard.table.${header.text}`)
                  }}</template>
                  <template v-slot:header.wojewodztwo>{{ $i18n.t('dashboard.offers.woj') }}</template>
                  <template v-slot:header.pow_dzialki="{ header }">{{
                    $i18n.t(`dashboard.table.${header.text}`)
                  }}</template>
                  <template v-slot:header.tools="{ header }">{{ $i18n.t(`dashboard.table.${header.text}`) }}</template>
                  <template v-slot:body="{ items }">
                    <draggable tag="tbody" :list="items" @start="drag = true" @end="drag = false">
                      <tr
                        v-for="(item, idx) in items"
                        :key="idx"
                        @click="selectRowByClick(item.id)"
                        :class="{
                          'table__row--background': item.id === selectedRow
                        }"
                      >
                        <td>
                          <v-text-field
                            v-model.number="item.custom_id"
                            class="input-offer-number"
                            type="number"
                            :step="1"
                            :rules="isInt"
                            @keydown="isNumber"
                            @change="changeOfferNumber(item.id, item.custom_id)"
                          />
                        </td>
                        <Attribute :item="item.nazwa_nieruchomosci" :class="{ 'name--bold': item.copied }" translate />
                        <Attribute :item="item.wojewodztwo" />
                        <Attribute :item="item.pow_dzialki" />
                        <td>
                          <v-icon
                            class="mr-2"
                            :title="$i18n.t(`dashboard.table.zoomToOffer`)"
                            small
                            @click="zoomToOfferById(item.id)"
                            >mdi-magnify</v-icon
                          >
                          <v-icon
                            class="mr-2"
                            :title="$i18n.t(`dashboard.projects.table.editOffer`)"
                            small
                            @click.stop="$router.push(`/offer/${item.id}`)"
                            >mdi-pencil</v-icon
                          >
                          <v-icon
                            class="mr-2"
                            :title="$i18n.t(`dashboard.projects.table.editDescription`)"
                            small
                            @click.stop="editProjetOfferDescription(item)"
                            >mdi-textbox</v-icon
                          >
                          <v-icon
                            class="mr-2"
                            :title="$i18n.t(`dashboard.table.delete`)"
                            small
                            @click.stop="prepareDeleteFromOffer(item)"
                            >mdi-delete</v-icon
                          >
                        </td>
                      </tr>
                    </draggable>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row no-gutters class="pt-3">
              <v-col cols="10">
                <v-tabs v-model="activeTabsUsers" ref="tabs_2">
                  <v-tab>{{ $i18n.t('projects.userList') }}</v-tab>
                  <v-tab>{{ $i18n.t('projects.changes') }}</v-tab>
                </v-tabs>
              </v-col>
              <v-col cols="2" class="pt-3 pr-3">
                <v-btn
                  v-if="activeTabsUsers === 0"
                  class="float-right"
                  fab
                  dark
                  small
                  color="primary"
                  :title="$i18n.t('projects.addUser')"
                  @click="openUserDialog"
                >
                  <v-icon dark>mdi-account-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="activeTabsUsers === 0" class="overflow-y-auto">
              <v-col cols="12" style="height: 100%">
                <CustomDataTable
                  :items="usersInProject"
                  :headers="usersHeaders"
                  entity-type="users"
                  :disable-pagination="true"
                >
                  <template v-slot:tools="{ item }">
                    <v-icon
                      class="mr-2"
                      :title="$i18n.t(`dashboard.projects.table.deleteUser`)"
                      small
                      @click="prepareDeleteFromOffer(item.user_name, 'users')"
                      >mdi-delete</v-icon
                    >
                  </template>
                </CustomDataTable>
              </v-col>
            </v-row>
            <v-row no-gutters class="overflow-y-auto" v-if="activeTabsUsers === 1">
              <v-col cols="12" style="height: 100%">
                <CustomDataTable
                  :items="changes"
                  :headers="changesHeaders"
                  entity-type="project"
                  :disable-pagination="true"
                  :has-tools="false"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="6" md="6" class="pt-0" style="height: 100%">
          <v-row style="height: 50%">
            <v-col cols="12" style="height: 100%" class="pt-0">
              <v-card height="100%" style="display: flex; flex-direction: column">
                <v-row no-gutters style="height: 100%">
                  <v-col class="pa-1" style="height: 100%">
                    <div style="height: 100%; width: 100%">
                      <DashboardMap
                        ref="map"
                        :offers="projectOffers"
                        @onSelectedId="selectRowById"
                        @clearSelection="clearSelection"
                        :has-filter="false"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-row style="height: 50%">
            <v-col cols="12" style="height: 100%" class="pb-0">
              <v-card height="100%" :class="activeTabStats == 0 ? 'project__card--links' : 'project__card--comments'">
                <v-row no-gutters>
                  <v-col cols="10" class="pa-1" style="height: 100%">
                    <div style="height: 100%; width: 100%">
                      <v-tabs v-model="activeTabStats" ref="tabs_3">
                        <v-tab>{{ $i18n.t('offer.stats.links') }}</v-tab>
                        <v-tab>{{ $i18n.t('offer.stats.activity') }}</v-tab>
                        <v-tab>{{ $i18n.t('offer.stats.comments') }}</v-tab>
                        <v-tab>{{ $i18n.t('offer.categories.attachments') }}</v-tab>
                      </v-tabs>
                    </div>
                  </v-col>
                  <v-col cols="2" class="pt-3 pr-3">
                    <v-btn
                      v-if="activeTabStats == 0"
                      class="float-right"
                      fab
                      dark
                      small
                      color="primary"
                      :title="$i18n.t('projects.addLink')"
                      @click="openActionDialog('addLink'), generateUuid()"
                    >
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="activeTabStats == 3 || activeTabStats == 2"
                      class="float-right"
                      fab
                      dark
                      small
                      color="primary"
                      :title="
                        activeTabStats === 2
                          ? $i18n.t('offer.comments.addComment')
                          : $i18n.t('offer.attachments.upload')
                      "
                      @click="addTableElement"
                    >
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                      class="btn--phone"
                      fab
                      dark
                      small
                      v-show="activeTabStats === 2"
                      color="primary"
                      :title="lastContactTitle"
                      @click="addLastContact"
                    >
                      <v-icon dark>mdi-cellphone-android</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="activeTabStats === 0" ref="table" class="pa-1 overflow-y-auto" no-gutters>
                  <v-col style="height: 100%">
                    <CustomDataTable
                      :items="projectLinks"
                      :headers="linksTableHeaders"
                      entity-type="links"
                      :disable-pagination="true"
                    >
                      <template #tools="{ item }">
                        <v-icon
                          class="mr-2"
                          :title="$i18n.t(`dashboard.projects.table.copyLink`)"
                          small
                          @click="copyLink(false, item.uuid)"
                          >mdi-content-copy</v-icon
                        >
                        <v-icon
                          class="mr-2"
                          :title="$i18n.t(`dashboard.projects.table.removeLink`)"
                          small
                          @click="deleteProjectLink(item)"
                          >mdi-delete</v-icon
                        >
                        <v-icon
                          class="mr-2"
                          :title="$i18n.t(`dashboard.projects.table.editLinkDescription`)"
                          small
                          @click="editDescription(item)"
                          >mdi-pencil</v-icon
                        >
                        <v-icon
                          class="mr-2"
                          :title="$i18n.t(`dashboard.projects.table.attachments`)"
                          small
                          @click="openShareAttachmentsModal(item)"
                        >
                          mdi-paperclip
                        </v-icon>
                      </template>
                    </CustomDataTable>
                  </v-col>
                </v-row>
                <v-row v-else-if="activeTabStats === 1" class="pa-1 overflow-y-auto" no-gutters>
                  <v-col xs="12" style="height: 100%">
                    <CustomDataTable
                      :items="offersStatistics"
                      :headers="statisticsTableHeaders"
                      entity-type="statistics"
                      :disable-pagination="true"
                      :has-tools="false"
                    ></CustomDataTable>
                  </v-col>
                </v-row>
                <v-row v-else-if="activeTabStats === 2" class="overflow-y-auto" no-gutters>
                  <v-col xs="12" style="height: 100%">
                    <CommentsTable
                      v-if="isProjectOffersFetched"
                      :entities="projectOffers"
                      :entity-id="entityID"
                      entity-type="project"
                    />
                  </v-col>
                </v-row>
                <v-row v-else-if="activeTabStats === 3" class="overflow-y-auto" no-gutters>
                  <v-col xs="12" style="height: 100%">
                    <AttachmentsTable
                      :attachmentEntitiesTypes="attachmentEntitiesTypes"
                      :entity-id="entityID"
                      entity-type="project"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <ConfirmDialog
        :dialog="confirmDialogVisible"
        v-if="confirmDialogLoaded"
        @success="dialogConfig[currentDialogContent].successFunction"
        @cancel="dialogConfig[currentDialogContent].cancelFunction"
      >
        <template v-slot:header>{{ dialogConfig[currentDialogContent].header }}</template>
        <template v-slot:content>
          <v-textarea
            maxlength="100"
            v-model="description"
            outlined
            counter
            v-if="
              currentDialogContent === 'editDescription' ||
              currentDialogContent === 'addNewProjetOfferDescription' ||
              currentDialogContent === 'editProjetOfferDescription'
            "
          />
          <span v-else>{{ dialogConfig[currentDialogContent].content }}</span>
        </template>
      </ConfirmDialog>

      <ActionDialog :isactiondialogactive="isActionDialogActive">
        <template v-slot:header>
          <span v-if="isDialogShow">{{ $i18n.t('dashboard.table.showLink') }}</span>
          <span v-else-if="isDialogAddLink">{{ $i18n.t('projects.addLink') }}</span>
          <span v-else-if="isDialogGetXLSX">{{ $i18n.t('dashboard.table.getXLSX') }}</span>
          <span v-else-if="isDialogGetPPTX">{{ $i18n.t('dashboard.table.getPPTX') }}</span>
        </template>
        <template v-slot:content>
          <span v-if="isDialogShow">
            <div id="uuid-container">{{ uuid }}</div>
          </span>
          <span v-else-if="isDialogAddLink">
            <v-row class="pl-0">
              <v-subheader>Wygenerowany link: {{ uuid }}</v-subheader>
            </v-row>
            <v-row>
              <v-textarea
                maxlength="100"
                v-model="linkDescription"
                outlined
                counter
                :label="$i18n.t('projects.linkDescription')"
                class="pa-4"
                :rules="[rules.required]"
              />
            </v-row>
            <v-row>
              <v-text-field
                v-model="linkPassword"
                :type="showPassword ? 'text' : 'password'"
                outlined
                :label="$i18n.t('projects.password')"
                class="pa-4"
                :rules="[rules.required]"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
              />
            </v-row>
          </span>
          <span v-else-if="isDialogGetXLSX">
            <v-form ref="xlsx">
              <v-row>
                <v-radio-group v-model="langXLSX" :mandatory="false" class="pl-2" @change="addTitleByLang('xlsx')">
                  <v-radio label="PL" value="pl" :rules="[rules.required]" />
                  <v-radio label="EN" value="en" />
                </v-radio-group>
              </v-row>
              <v-row>
                <v-text-field
                  v-model="titleXLSX"
                  outlined
                  :label="$i18n.t('dashboard.table.xlsxTitle')"
                  class="pl-2"
                  :rules="[rules.required, rules.max50]"
                />
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-list subheader>
                    <v-list-item-group>
                      <v-list-item v-for="(value, key) in attributesSchema" :key="key">
                        <template v-slot:default>
                          <v-list-item-action>
                            <v-checkbox v-model="categoriesToXLSX" color="primary" :value="key" />
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>{{ $i18n.t(`offer.categories.${key}`) }}</v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>
            </v-form>
          </span>
          <span v-else-if="isDialogGetPPTX">
            <v-form ref="pptx">
              <v-row>
                <v-radio-group v-model="langPPTX" :mandatory="false" class="pl-2" @change="addTitleByLang('pptx')">
                  <v-radio label="PL" value="pl" :rules="[rules.required]" />
                  <v-radio label="EN" value="en" />
                </v-radio-group>
              </v-row>
              <v-row>
                <v-text-field
                  v-model="titlePPTX"
                  outlined
                  :label="$i18n.t('dashboard.table.pptxTitle')"
                  class="pl-2"
                  :rules="[rules.required, rules.max50]"
                />
              </v-row>
              <v-row>
                <v-text-field
                  v-model="subtitlePPTX"
                  outlined
                  :label="$i18n.t('dashboard.table.pptxSubtitle')"
                  class="pl-2"
                  :rules="[rules.required, rules.max50]"
                />
              </v-row>
              <v-row>
                <v-select
                  multiple
                  :items="pptxEmails"
                  v-model="contactPersons"
                  outlined
                  :label="$i18n.t('dashboard.table.pptxPersons')"
                  class="pl-2"
                  :rules="[rules.requiredArray]"
                  :menu-props="{ nudgeBottom: '57' }"
                />
              </v-row>
            </v-form>
          </span>
        </template>
        <template v-slot:buttons>
          <v-card-actions class="justify-space-between">
            <v-btn
              v-if="isDialogShow"
              color="primary"
              text
              :title="$i18n.t('dialog.confirmation.copyLink')"
              @click="copyLink('uuid-container')"
              >{{ $i18n.t('dialog.confirmation.copy') }}</v-btn
            >
            <v-btn
              v-else-if="isDialogAddLink"
              color="primary"
              text
              :title="$i18n.t('dialog.confirmation.save')"
              @click="addLink"
              >{{ $i18n.t('dialog.confirmation.save') }}</v-btn
            >

            <v-btn
              v-else-if="isDialogGetXLSX"
              color="primary"
              text
              :title="$i18n.t('dialog.confirmation.save')"
              @click="createXLSX"
              >{{ $i18n.t('dialog.confirmation.save') }}</v-btn
            >
            <v-btn
              v-else-if="isDialogGetPPTX"
              color="primary"
              text
              :title="$i18n.t('dialog.confirmation.save')"
              @click="createPPTX"
              >{{ $i18n.t('dialog.confirmation.save') }}</v-btn
            >

            <v-btn color="primary" text @click="closeActionDialog">{{
              $i18n.t('dialog.confirmation.close')
            }}</v-btn>
          </v-card-actions>
        </template>
      </ActionDialog>
      <AttributesSettings
        :project-id="entityID"
        v-if="attributesSettingsLoaded"
        :is-visible="attributesSettingsVisibility"
        @closeAtrributes="closeAttributesSettings"
      />
      <!--  -->
      <LinkAttachmentsDialog
        :isVisible.sync="isShareAttachmentsModalVisisble"
        :project-id="entityID"
        :project-link="item"
        :success="successfullyEditedLinkAttachments"
      />
      <DefaultDialog
        :dialog="isDefaultDialogVisible"
        v-if="isDefaultDialogLoaded"
        @cancel="isDefaultDialogVisible = false; $refs.wojPowGmiFilter.woj = undefined"
        max-width="95%"
      >
        <template v-slot:header>
          <h1>{{ $i18n.t('project.addOfferToProjectTitle') }}</h1>
        </template>
        <template v-slot:content>
          <div class="project-offer-dialog-content">
            <SelectFilterWojPowGmi ref="wojPowGmiFilter" @wpg="wpg = $event" />
            <CustomDataTable :items="tableOffers" :headers="dialogTableHeaders" entity-type="project">
              <template v-slot:tools="{ item }">
                <v-icon
                  small
                  icon
                  :title="$i18n.t('tables.parcels.tools.addToProject')"
                  @click="addNewProjetOfferDescription(item)"
                  >mdi-plus</v-icon
                >
              </template>
            </CustomDataTable>
          </div>
        </template>
      </DefaultDialog>

      <DefaultDialog
        :dialog="isUserDialogVisible"
        v-if="isDefaultDialogLoaded"
        @cancel="isUserDialogVisible = false"
        max-width="30%"
      >
        <template v-slot:header>
          <h1>{{ $i18n.t('projects.addUser') }}</h1>
        </template>
        <template v-slot:content>
          <v-row>
            <v-col cols="12">
              <CustomDataTable
                :items="usersOutOfProject"
                :headers="usersHeaders"
                entity-type="users"
                :disable-pagination="true"
              >
                <template v-slot:tools="{ item }">
                  <v-icon class="mr-2" :title="$i18n.t('projects.addUser')" small @click="addUserToProject(item)"
                    >mdi-account-plus</v-icon
                  >
                </template>
              </CustomDataTable>
            </v-col>
          </v-row>
        </template>
      </DefaultDialog>
    </v-container>
  </v-form>
</template>

<script>
import DashboardMap from '@/components/dashboard/DashboardMap';
import ActionDialog from '@/components/project/ActionDialog';
import AttachmentsTable from '@/components/AttachmentsTable';
import CommentsTable from '@/components/CommentsTable';

import draggable from 'vuedraggable';
// zastąpić atrybutami pobieranymi z routingu /offer/:id
import { TEST_ATTRIBUTES } from '@/models/Offer';
import Attribute from '@/components/dashboard/Attribute';
import CustomDataTable from '@/components/CustomDataTable';
import axios from 'axios';

// mixins
import entityBasicMixin from '@/mixins/entityBasicMixin';
import tabsMixin from '@/mixins/tabsMixin';
import sortMixin from '@/mixins/sortMixin';

export default {
  mixins: [entityBasicMixin, tabsMixin, sortMixin],
  components: {
    ConfirmDialog: () => import('@/components/ConfirmDialog'),
    DefaultDialog: () => import('@/components/DefaultDialog'),
    CommentsTable,
    CustomDataTable,
    AttachmentsTable,
    ActionDialog,
    DashboardMap,
    draggable,
    AttributesSettings: () => import('@/components/project/AttributesSettings'),
    Attribute,
    SelectFilterWojPowGmi: () => import('@/components/SelectFilterWojPowGmi'),
    LinkAttachmentsDialog: () => import('@/components/project/LinkAttachmentsDialog')
  },
  data: function () {
    return {
      activeTab: undefined,
      activeTabStats: undefined,
      activeTabsUsers: undefined,
      addingElement: 'comments',
      attachments: [],
      attributesSchema: {},
      // attributes: TEST_ATTRIBUTES,
      changes: [],
      comments: [],
      currentDialogContent: 'deleteOffer',
      deleteFrom: undefined,
      description: undefined,
      drag: false,
      idsStats: [],
      isDialogShow: false,
      isDialogAddLink: false,
      isDialogGetXLSX: false,
      isUserDialogVisible: false,
      isDialogGetPPTX: false,
      isEditableOffer: true,
      isLegendActive: false,
      isActionDialogActive: false,
      attributesSettingsVisibility: false,
      attributesSettingsLoaded: false,
      isCommentAttachmentModal: false,
      isProjectActive: false,
      pptxEmails: [], //['beata.hryniewska@cbre.com', 'aleksander.kuzniewski@cbre.com', 'michal.zelazek@cbre.com'],
      projectNamePL: '',
      projectNameEN: '',
      projectAbstractPL: '',
      projectAbstractEN: '',
      projectOffers: [],
      projectOffersAttributes: [],
      offersStatistics: [],
      project: {
        title: {}
      },
      usersInProject: [],
      usersHeaders: [{ text: 'user_name', align: 'start', value: 'user_name', type: 'text' }],
      changesHeaders: [
        {
          text: 'description',
          value: 'description',
          type: 'text',
          translate: false
        },
        {
          text: 'timestamp',
          value: 'timestamp',
          type: 'date',
          translate: false
        },
        {
          text: 'user_id',
          value: 'user_id',
          type: 'number',
          translate: false
        }
      ],
      usersToAdd: [],
      categoriesToXLSX: [],
      titleXLSX: undefined,
      langXLSX: undefined,

      titlePPTX: undefined,
      subtitlePPTX: undefined,
      contactPersons: [],
      langPPTX: undefined,

      itemToDelete: undefined,
      linkDescription: undefined,
      linkPassword: undefined,
      allOffers: [],

      offers: [],
      name: '',

      dialogTableHeaders: [
        {
          text: 'nazwa_nieruchomosci',
          value: 'nazwa_nieruchomosci',
          type: 'text',
          translate: true
        },
        {
          text: 'wojewodztwo',
          value: 'wojewodztwo',
          type: 'text',
          translate: false
        },
        {
          text: 'pow_dzialki',
          value: 'pow_dzialki',
          type: 'number'
        }
      ],
      linksTableHeaders: [
        {
          text: 'created_at',
          value: 'created_at',
          type: 'date'
        },
        {
          text: 'abstract',
          value: 'abstract',
          type: 'text'
        }
      ],
      statisticsTableHeaders: [
        {
          text: 'offer_title',
          value: 'offer_title',
          type: 'text',
          translate: true
        },
        {
          text: 'click',
          value: 'event_count_per_type.click',
          type: 'number'
        }
      ],
      isProjectOffersFetched: false,
      tableLoading: true,
      parcels: {},
      projectDescription: '',
      projectLinks: [],
      rules: {
        required: value => !!value || this.$i18n.t('default.requiredField'),
        max50: value => (value ? value.length <= 50 || this.$i18n.t('default.max50') : true),
        requiredArray: value => value.length > 0 || this.$i18n.t('default.requiredField')
      },
      selectedItemIndex: undefined,
      selectedRow: undefined,
      showPassword: false,
      currentUuid: undefined,
      uuid: undefined,
      uuidToEdit: undefined,

      // Components settings variables
      confirmDialogLoaded: false,
      confirmDialogVisible: false,
      isEditing: false,
      isDefaultDialogLoaded: false,
      isDefaultDialogVisible: false,

      wpg: {
        woj: undefined,
        pow: undefined,
        gmi: undefined
      },
      isShareAttachmentsModalVisisble: false,
      item: {}
    };
  },
  computed: {
    attachmentEntitiesTypes() {
      return [
        {
          label: this.$i18n.t('offer.attachments.toTheEntireProject'),
          value: 'project'
        },
        {
          label: this.$i18n.t('offer.attachments.toTheSingleOffer'),
          value: 'offer',
          items: this.projectOffers.map(pOffer => {
            return { text: pOffer.nazwa_nieruchomosci[this.$i18n.locale], value: pOffer.id };
          })
        }
      ];
    },
    offersTableHeaders() {
      return [
        {
          text: 'custom_id',
          value: 'custom_id',
          type: 'number',
          sortable: true
        },
        {
          text: 'nazwa_nieruchomosci',
          value: 'nazwa_nieruchomosci',
          type: 'text',
          translate: true,
          sort: (a, b) => this.sortTranslatedObjects(a, b)
        },
        {
          text: 'wojewodztwo',
          value: 'wojewodztwo',
          type: 'text',
          translate: false
        },
        {
          text: 'pow_dzialki',
          value: 'pow_dzialki',
          type: 'number'
        },
        {
          text: 'tools',
          value: 'tools',
          align: 'center',
          sortable: false
        }
      ];
    },
    allUsers() {
      return this.$store.getters.getUsers.map(user => Object.assign({ user_name: user }));
    },
    usersOutOfProject() {
      return this.allUsers.filter(user => !this.usersInProject.some(u => u.user_name === user.user_name));
    },
    dialogConfig() {
      return {
        deleteProjectOffer: {
          header: this.$i18n.t('dialog.header.deleteOffer'),
          content: this.$i18n.t('dialog.content.deleteOffer'),
          successFunction: this.deleteProjectOffer,
          cancelFunction: this.deleteConfirmCancel
        },
        deleteLink: {
          header: this.$i18n.t('dialog.header.deleteLink'),
          content: this.$i18n.t('dialog.content.deleteLink'),
          successFunction: this.deleteLink,
          cancelFunction: this.deleteConfirmCancel
        },
        editDescription: {
          header: this.$i18n.t('dialog.header.editOfferDescription'),
          successFunction: this.acceptLinkDescription,
          cancelFunction: this.cancelDescription
        },
        addNewProjetOfferDescription: {
          header: this.$i18n.t('dialog.header.addOfferDescription'),
          successFunction: this.addOfferToProject,
          cancelFunction: this.cancelDescription
        },
        editProjetOfferDescription: {
          header: this.$i18n.t('dialog.header.editOfferDescription'),
          successFunction: this.acceptEditProjetOfferDescription,
          cancelFunction: this.cancelDescription
        },
        deleteUser: {
          header: this.$i18n.t('dialog.header.deleteUser'),
          content: this.$i18n.t('dialog.content.deleteUser'),
          successFunction: this.deleteUser,
          cancelFunction: this.deleteConfirmCancel
        }
      };
    },
    isInt() {
      return [v => Number.isInteger(parseInt(v)) || ''];
    },
    tableOffers() {
      const offersIds = this.projectOffers.map(offer => offer.id);
      const wpg = this.wpg;
      return this.allOffers.filter(offer => {
        if (offer.keeper !== 'CBRE') {
          return false;
        }
        if (offersIds.includes(offer.id)) {
          return false;
        }
        if (wpg.woj && offer.wojewodztwo !== wpg.woj.jpt_nazwa_) {
          return false;
        }
        if (wpg.pow && offer.powiat !== wpg.pow.jpt_nazwa_) {
          return false;
        }
        if (wpg.gmi && offer.gmina !== wpg.gmi.jpt_nazwa_) {
          return false;
        }
        return true;
      });
    },
    lastContactTitle() {
      const date = new Date().toLocaleString('pl-PL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
      return this.$i18n.t('offer.comments.addLastContact') + ': ' + date;
    }
  },
  filters: {
    filterLength(value) {
      if (value.length > 40) {
        return `${value.substring(0, 40)}...`;
      } else {
        return value;
      }
    }
  },
  methods: {
    addLastContact() {
      this.$root.$emit('addLastContactComment');
    },
    addNewProjetOfferDescription(item) {
      this.item = item;
      this.currentDialogContent = 'addNewProjetOfferDescription';
      this.confirmDialogLoaded = true;
      this.confirmDialogVisible = true;
    },
    editProjetOfferDescription(item) {
      this.item = item;
      this.currentDialogContent = 'editProjetOfferDescription';
      if (item.hasOwnProperty('description')) {
        this.description = item.description;
      }
      this.confirmDialogLoaded = true;
      this.confirmDialogVisible = true;
    },
    successfullCallback() {
      this.item.description = this.description;
      this.description = '';
      this.confirmDialogVisible = false;
    },
    async acceptEditProjetOfferDescription() {
      try {
        const payload = {
          description: this.description,
          offer: this.item.id,
          project: this.entityID
        };
        const response = await this.$store.dispatch('editProjectOfferAttributes', payload);
        this.successfullCallback();
        this.getProjectChanges();
      } catch (e) {
        this.$root.$emit('showSnackbar', e);
      }
    },
    addOfferToProject() {
      axios({
        method: 'post',
        url: '/projects_offers',
        data: {
          offer: this.item.id,
          project: this.entityID,
          description: this.description
        }
      })
        .then(r => {
          if (r) {
            this.successfullCallback();
            this.projectOffers.push(this.item);
            this.currentDialogContent = 'deleteProjectOffer';
            this.$root.$emit('showSnackbar', this.$i18n.t('project.offerAddedToProject'));
            this.getProjectChanges();
          }
          return false;
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    },
    addTitleByLang(element) {
      if (element === 'xlsx') {
        this.titleXLSX = this.project.title[this.langXLSX];
      } else {
        this.titlePPTX = this.$i18n.t('dashboard.table.pptxAreasProposals');
        this.subtitlePPTX = this.$i18n.t('dashboard.table.pptxEnterANameOrRegion');
      }
    },
    acceptEditing() {
      let payload = {
        id: this.entityID,
        pl: this.projectNamePL,
        en: this.projectNameEN,
        pl_desc: this.projectAbstractPL,
        en_desc: this.projectAbstractEN
      };
      this.$store.dispatch('acceptProjectEditing', payload).then(r => {
        if (r.status === 200) {
          this.$root.$emit('showSnackbar', this.$i18n.t('projects.tools.edited'));
          this.project.title.pl = this.projectNamePL;
          this.project.title.en = this.projectNameEN;
          this.project.abstract = { pl: this.projectAbstractPL, en: this.projectAbstractEN };
          this.stopEditing();
          this.getProjectChanges();
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
        }
      });
    },
    // Display offer description modal
    addDescription(item) {
      this.currentDialogContent = 'editDescription';
      this.item = item;
      if (item.hasOwnProperty('description')) {
        this.description = item.description;
      }
      this.confirmDialogLoaded = true;
      this.confirmDialogVisible = true;
    },
    editDescription(item) {
      this.currentDialogContent = 'editDescription';
      this.item = item;
      this.uuidToEdit = item.uuid;
      this.description = item.abstract;
      this.confirmDialogLoaded = true;
      this.confirmDialogVisible = true;
    },
    openShareAttachmentsModal(item) {
      this.item = item;
      this.isShareAttachmentsModalVisisble = true;
    },
    // Accept offer description
    acceptLinkDescription() {
      const payload = {
        id: this.entityID,
        uuid: this.uuidToEdit,
        abstract: this.description
      };
      this.$store
        .dispatch('editProjectLink', payload)
        .then(r => {
          if (r.status === 200) {
            this.successfullCallback();

            this.password = '';
            this.$root.$emit('showSnackbar', this.$i18n.t(`dialog.header.editedLink`));
            this.getProjectLinks();
            this.getProjectChanges();
          } else {
            this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
          }
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    },
    addTableElement() {
      if (this.activeTabStats === 2) {
        this.$root.$emit('openCommentsDialog');
      } else if (this.activeTabStats === 3) {
        this.$root.$emit('openAttachmentsDialog');
      }
    },
    addLink() {
      if (!this.$refs.form.validate()) return;
      const payload = {
        id: this.entityID,
        abstract: this.linkDescription,
        password: this.linkPassword,
        uuid: this.uuid.substring(this.uuid.lastIndexOf('/') + 1)
      };
      this.$store
        .dispatch('addProjectLink', payload)
        .then(r => {
          if (r.status === 200 || r.status === 201) {
            this.getProjectLinks();
            /*
            this.projectLinks.push({
              created_at: new Date().toLocaleDateString('pl'),
              abstract: this.linkDescription
            });*/
            this.closeActionDialog();
            this.getProjectChanges();
            this.linkPassword = '';
          } else {
            this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
          }
        })
        .catch(e => {
          this.$root.$emit('showSnacbar', e);
        });
    },
    openUserDialog() {
      if (this.usersOutOfProject.length === 0) {
        this.$root.$emit('showSnackbar', this.$i18n.t('users.noUsersLeft'));
      } else {
        this.isUserDialogVisible = true;
        this.isDefaultDialogLoaded = true;
      }
    },
    async addUserToProject(user) {
      const { user_name } = user;
      try {
        const response = await axios.post(`/projects_users/${this.entityID}`, {
          data: {
            user_name
          }
        });
        this.usersInProject.push({
          user_name,
          project: this.entityID
        });
        this.getProjectChanges();
        if (this.usersOutOfProject.length === 0) {
          this.isUserDialogVisible = false;
          this.$root.$emit('showSnackbar', this.$i18n.t('users.noUsersLeft'));
        }
      } catch (e) {
        this.$root.$emit('showSnackbar', e);
      }
    },
    cancelDescription() {
      this.description = '';
      this.confirmDialogVisible = false;
    },
    changeOfferNumber(id, custom_id) {
      if (!custom_id) {
        return;
      }
      const data = {
        project: this.entityID,
        offer: id,
        custom_id: custom_id
      };
      this.$store
        .dispatch('editProjectOfferAttributes', data)
        .then(r => {
          if (r.status === 200) {
          } else {
          }
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    },
    clearSelection() {
      this.selectedRow = undefined;
      this.$refs.map.selectOfferById(undefined);
    },
    closeActionDialog() {
      this.isActionDialogActive = false;
      if (this.isDialogShow) {
        this.isDialogShow = false;
      }
      if (this.isDialogAddLink) {
        this.isDialogAddLink = false;
        this.linkDescription = undefined;
      }
      if (this.isDialogGetXLSX) {
        this.isDialogGetXLSX = false;
      }
      if (this.isDialogGetPPTX) {
        this.isDialogGetPPTX = false;
      }
    },
    closeAttributesSettings() {
      this.attributesSettingsVisibility = false;
    },
    closeCommAttachModal() {
      this.isCommentAttachmentModal = false;
    },
    closeMapLegend() {
      this.isLegendActive = false;
      this.isProjectActive = false;
    },
    copyLink(copyFrom, uuid) {
      // crossbrowser solution
      if (!copyFrom) {
        uuid = uuid;
      } else {
        uuid = document.getElementById(copyFrom).value;
      }
      const dummy = document.createElement('input');
      document.body.appendChild(dummy);
      dummy.setAttribute('id', 'dummy_id');
      dummy.value = window.location.origin + '/presentation/' + uuid;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      this.$root.$emit('showSnackbar', this.$i18n.t('default.copiedToClipboard'));
    },
    createPPTX() {
      if (this.$refs.pptx.validate()) {
        this.$store
          .dispatch('createPPTX', {
            project_id: this.entityID,
            lang: this.langPPTX,
            title: this.titlePPTX,
            subtitle: this.subtitlePPTX,
            maintainers: this.contactPersons.join(),
          })
          .then(r => {
            if (r.status === 202) {
              const process_id = r.data.process_id;
              this.$store.commit('setProcess', {
                id: process_id,
                title: this.titlePPTX,
                subtitle: this.subtitlePPTX,
              });
              this.$root.$emit('showSnackbar', this.$i18n.t('dashboard.table.pptxProcessStart'));
              this.langPPTX = undefined;
              this.titlePPTX = undefined;
              this.subtitlePPTX = undefined;
              this.contactPersons = [];
              this.closeActionDialog();
            } else {
              this.$root.$emit('showSnackbar', this.$i18n.t('dashboard.table.pptxError'));
            }
          });
      } else {
        this.$root.$emit('showSnackbar', this.$i18n.t('dashboard.table.emptyFields'));
      }
    },
    createXLSX() {
      if (this.$refs.xlsx.validate()) {
        this.$store
          .dispatch('createXLSX', {
            project_id: this.entityID,
            lang: this.langXLSX,
            title: this.titleXLSX,
            groups: this.categoriesToXLSX.join()
          })
          .then(r => {
            if (r.status == 200) {
              const blob = new Blob([r.data], { type: '' });
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = `${this.titleXLSX}.xlsx`;
              link.click();

              this.titleXLSX = undefined;
              this.categoriesToXLSX = [];
              this.closeActionDialog();
            } else {
              this.$root.$emit('showSnackbar', this.$i18n.t('dashboard.table.xlsxError'));
            }
          });
      } else {
        this.$root.$emit('showSnackbar', this.$i18n.t('dashboard.table.emptyFields'));
      }
    },

    deleteConfirmCancel() {
      this.confirmDialogVisible = false;
    },
    deleteProjectOffer() {
      this.$store
        .dispatch('deleteProjectOffer', {
          project: this.entityID,
          offer: this.itemToDelete.id
        })
        .then(() => {
          const index = this.projectOffers.indexOf(this.itemToDelete);
          this.projectOffers.splice(index, 1);
          this.confirmDialogVisible = false;
          this.$root.$emit('showSnackbar', this.$i18n.t(`default.successfullyDeletedProjectOffer`));
          this.getProjectChanges();
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    },
    deleteElement(item) {
      const offer = this[item].find(el => el == this.itemToDelete);
      const index = this[item].indexOf(offer);
      this[item].splice(index, 1);
      this.confirmDialogVisible = false;
    },
    deleteLink() {
      let payload = {
        id: this.entityID,
        uuid: this.itemToDelete.uuid
      };
      this.$store.dispatch('deleteLink', payload).then(r => {
        if (r.status === 200) {
          this.$route.$emit('showSnackbar', this.$i18n.t(`dialog.deleteLink`));
          const link = this.projectLinks.find(el => el == this.itemToDelete);
          const index = this.projectLinks.indexOf(link);
          this.project.splice(index, 1);
          this.confirmDialogVisible = false;
          this.getProjectChanges();
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
        }
      });
    },
    deleteProjectLink(linkToDelete) {
      let payload = {
        id: this.entityID,
        uuid: linkToDelete.uuid
      };
      this.$store.dispatch('deleteLink', payload).then(r => {
        if (r.status === 200) {
          this.$root.$emit('showSnackbar', this.$i18n.t('dialog.header.deletedLink'));
          const link = this.projectLinks.find(el => el == linkToDelete);
          const index = this.projectLinks.indexOf(link);
          this.projectLinks.splice(index, 1);
          //this.confirmDialogVisible = false;
          this.getProjectChanges();
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
        }
      });
    },
    async deleteUser() {
      try {
        const response = await axios.delete(`/projects_users/${this.entityID}?user=${this.itemToDelete}`);
        if (response.status === 200) {
          const usersNames = this.usersInProject.map(user => user.user_name);
          const index = usersNames.indexOf(this.itemToDelete);
          this.usersInProject.splice(index, 1);
          this.confirmDialogVisible = false;
          this.getProjectChanges();
        }
      } catch (e) {
        this.$root.$emit('showSnackbar', e);
      }
    },
    dragReorder({ oldIndex, newIndex }) {
      const movedItem = this.projectOffers.splice(oldIndex, 1)[0];
      this.projectOffers.splice(newIndex, 0, movedItem);
    },
    getAttributeValue(item, eventType) {
      const eventObject = item.event_count_per_type.find(type => type.event_type === eventType);
      return eventObject ? eventObject.count : 0;
    },
    generateUuid() {
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
      this.uuid = `${window.location.origin}/presentation/${uuid}`;
    },
    getProject() {
      return axios({
        method: 'get',
        url: '/projects/' + this.entityID
      })
        .then(r => {
          if (r) {
            this.project = r.data.projects;
          }
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    },
    getProjectLinks() {
      return axios({
        method: 'get',
        url: '/projects_links/' + this.entityID
      })
        .then(r => {
          if (r) {
            this.projectLinks = r.data.projects_links.reverse();
            if (r.data.projects_links.length > 0) {
              this.currentUuid = r.data.projects_links[0].uuid;
            }
          }
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    },
    getProjectChanges() {
      return axios({
        method: 'get',
        url: `/projects_history/${this.entityID}`
      })
        .then(r => {
          if (r) {
            this.changes = r.data.projects_history.reverse();
          }
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    },
    async getMaintainersEmails() {
      try {
        const req = await axios.get('/maintainers?emails_only=true');
        this.pptxEmails = req.data.data;
      } catch (e) {
        this.$root.$emit('showSnackbar', e.response.data.error);
      }
    },
    async getUsersInProject() {
      try {
        const req = await axios.get(`/projects_users/${this.entityID}`);
        this.usersInProject = req.data.projects_users;
      } catch (e) {
        this.$root.$emit('showSnackbar', e.response.data.error);
      }
    },

    async openActionDialog(linkType) {
      if (linkType === 'show') {
        this.isDialogShow = true;
      } else if (linkType === 'addLink') {
        this.isDialogAddLink = true;
      } else if (linkType === 'getXLSX') {
        const response = await this.getAttributesSchema();
        this.titleXLSX = this.project.title[this.$i18n.locale];
        this.langXLSX = this.$i18n.locale;
        this.isDialogGetXLSX = true;
      } else if (linkType === 'getPPTX') {
        const response = await this.getAttributesSchema();
        this.titlePPTX = this.$i18n.t('dashboard.table.pptxAreasProposals');
        this.subtitlePPTX = this.$i18n.t('dashboard.table.pptxEnterANameOrRegion');
        this.langPPTX = this.$i18n.locale;
        this.isDialogGetPPTX = true;
      }
      this.isActionDialogActive = true;
    },
    openMapLegend() {
      this.isProjectActive = true;
      this.isLegendActive = true;
    },
    prepareDeleteFromOffer(item, entity) {
      if (item.hasOwnProperty('creationDate')) {
        this.currentDialogContent = 'deleteLink';
      } else if (entity === 'users') {
        this.currentDialogContent = 'deleteUser';
      } else {
        this.currentDialogContent = 'deleteProjectOffer';
      }
      this.confirmDialogLoaded = true;
      this.confirmDialogVisible = true;
      this.itemToDelete = item;
    },
    saveLayers() {
      this.$root.$emit('showSnackbar', this.$i18n.t('dashboard.map.saveLayersSuccess'));
    },
    selectRowByClick(id) {
      if (this.selectedRow == id) {
        id = undefined;
      }
      this.selectedRow = id;
      this.$refs.map.selectOfferById(id);
    },
    selectRowById(id) {
      this.selectedRow = id;
    },
    async getAttributesSchema() {
      if (Object.keys(this.attributesSchema).length === 0) {
        try {
          const response = await this.$store.dispatch('getOffer', {
            id: 'schema'
          });
          this.attributesSchema = response.data.data;
        } catch (e) {
          this.$root.$emit('showSnackbar', e);
        }
      } else {
        Promise.resolve();
      }
    },
    showAttributesSettings() {
      this.attributesSettingsVisibility = true;
      this.attributesSettingsLoaded = true;
    },
    showDefaultDialog() {
      if (this.tableOffers.length) {
        this.isDefaultDialogLoaded = true;
        this.isDefaultDialogVisible = true;
      } else {
        this.$root.$emit('showSnackbar', this.$i18n.t('project.projectInludesAllOffers'));
      }
    },
    startEditing() {
      this.projectNamePL = this.project.title.pl;
      this.projectNameEN = this.project.title.en;
      this.projectAbstractPL = this.project.abstract.pl;
      this.projectAbstractEN = this.project.abstract.en;
      this.isEditing = true;
    },
    stopEditing() {
      this.isEditing = false;
    },
    successfullyEditedLinkAttachments() {
      this.getProjectLinks();
      this.getProjectChanges();
    },
    zoomToOfferById(id) {
      this.$refs.map.zoomToOfferById(id);
    },
    init() {
      if (this.entityID === 'new') {
        if (this.$store.getters.getCenter) {
          this.$refs.map.setView(this.$store.getters.getCenter, this.$store.getters.getZoom, true);
        }
      } else {
        this.getProject();
        this.getProjectLinks();
        this.getProjectChanges();
        this.getUsersInProject();
        this.getMaintainersEmails();
        const getProjectOffersRequest = axios({
          method: 'get',
          url: '/projects_offers',
          params: {
            project: this.entityID
          }
        })
          .then(r => {
            if (r.status === 200) {
              return r.data.offers;
            }
          })
          .catch(e => {
            this.$root.$emit('showSnackbar', e);
          });

        const getProjectOffersAttributes = axios({
          method: 'get',
          url: '/projects_offers/attributes',
          params: {
            project: this.entityID
          }
        })
          .then(r => {
            if (r.status === 200) {
              return r.data.project_offers;
            }
          })
          .catch(e => {
            this.$root.$emit('showSnackbar', e);
          });

        const getProjectOffersStats = axios({
          method: 'get',
          url: `/projects/stats`
        })
          .then(r => {
            if (r) {
              return r.data.stats;
            }
          })
          .catch(e => {
            this.$root.$emit('showSnackbar', e);
          });
        Promise.all([
          this.$store.dispatch('getOffers'),
          getProjectOffersRequest,
          getProjectOffersAttributes,
          getProjectOffersStats
        ]).then(([oRes, poRes, poA, poStats]) => {
          this.offers = oRes;
          this.allOffers = oRes;
          this.projectOffersAttributes = poA;
          this.projectOffers = oRes.filter(offer => poRes.includes(offer.id));
          this.isProjectOffersFetched = true;
          this.$nextTick(() => {
            for (let idx in this.projectOffers) {
              const offerID = this.projectOffers[idx].id;
              this.projectOffers[idx]['custom_id'] = this.projectOffersAttributes.find(
                po => po.offer === offerID
              ).custom_id;
              this.projectOffers[idx]['description'] = this.projectOffersAttributes.find(
                po => po.offer === offerID
              ).description;
            }
            for (let stat of poStats) {
              if (
                stat.offer_id &&
                stat.project_id &&
                stat.project_id == this.entityID &&
                stat.event_count_per_type.click
              ) {
                this.offersStatistics.push(stat);
              }
            }
            this.tableLoading = false;
            this.$refs.map.zoomToExtent(this.$refs.map.getLayerByName('offers').getSource().getExtent());
          });
        });
      }
    }
  },
  mounted() {
    this.init();
    this.$store.dispatch('fetchUsers');
    /*
    setTimeout(() => {
      this.$store.commit('pushProcessId', 5);
    }, 5000);
    setTimeout(() => {
      this.$store.commit('pushProcessId', 6);
    }, 10000);
    setTimeout(() => {
      this.$store.commit('pushProcessId', 7);
    }, 15000);
    */
  }
};
</script>
<style lang="scss">
html {
  overflow: auto;
}
.expansion__panel--table {
  height: 300px;
}
.table {
  height: 100%;
}
.attributes {
  height: calc(100% - 65px);
  overflow-y: auto;
}
div.v-data-table__wrapper.vb-content {
  height: inherit !important;
}
.table__row--tools {
  text-align: center;
}
#table-offers > div.v-data-table__wrapper.vb-content > table > thead > tr > th.text-center {
  display: flex;
  justify-content: center;
  align-items: self-start;
  box-shadow: none;
}
.project__card--left,
.project__card--comments,
.project__card--links {
  display: grid !important;
  grid-template-columns: 1fr;
  grid-gap: 0;
}
th.text-center {
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.12);
}
.project__card--left {
  grid-template-rows: auto 80px 1fr 75px 0.8fr;
}
.project__card--comments {
  grid-template-rows: 80px 1fr;
}
.project__card--links {
  grid-template-rows: 80px 1fr;
}
.project {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 26px;
}
.project__button--cancel {
  margin-right: 24px;
}
.project__button--disabled {
  background-color: rgba($primary-color, 0.4) !important;
  pointer-events: none !important;
}
.project__checkbox {
  height: 30px;
  width: 10px;
  margin-top: 0;
}
#table-offers,
#table-offers-stats,
#table-users,
#table-changes {
  height: 100%;

  th.text-center {
    line-height: 48px;
  }
}
#table-offers > div > table > tbody > tr > td {
  overflow: hidden;
  max-width: 150px;
  word-wrap: break-word;
}
#table-users {
  .v-responsive.v-image {
    height: 40px;
    min-width: 40px;
    width: 40px;
    border-radius: 100%;
  }
  .v-list-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
}
.text--black {
  color: black;
}
::-webkit-scrollbar {
  width: 7px;
}
::-webkit-scrollbar:hover ::-webkit-scrollbar {
  width: 12px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba($primary-color, 0.2);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba($primary-color, 0.5);
  width: 12px;
}
.table__row--background {
  background-color: rgba($primary-color, 0.2) !important;
}
.sub-text {
  font-size: 14px;
  color: lightgrey;
}
.project-offer-dialog-content {
  .v-data-footer {
    position: sticky;
    bottom: 0;
    background-color: white;
    margin-right: 0 !important;
  }
}
.btn--phone {
  position: absolute;
  right: 60px;
  top: 12px;
}
.input-offer-number {
  width: 40px;
}
.input-offer-number input[type='number'] {
  text-align: center;
  font-size: 14px;
  -moz-appearance: textfield;
}
.input-offer-number input::-webkit-outer-spin-button,
.input-offer-number input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
#table-offers > div.v-data-table__wrapper.vb-content > table > thead > tr > th.text-center {
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.12);
}
.tooltip__span {
  overflow-wrap: anywhere;
}
</style>
